export const authTokenURL = '/authorizationserver/oauth/token';

export const authRevokeURL = '/authorizationserver/oauth/revoke';
